document.addEventListener("DOMContentLoaded", function () {
    //fancybox
    const productGall = document.getElementById('product-gall');
    if (productGall !== null) {
        Fancybox.bind("#product-gall [data-fancybox]", {
            groupAll: true,
            Thumbs: false,
            Toolbar: {
                display: {
                    left: [],
                    right: ["close"],
                },
            },
        });
    }
    //fancybox
});

window.addEventListener('scroll', function() {
    const triggerElement = document.getElementById('trigger-element');
    const addToCartButton = document.querySelector('[data-btn-add-to-cart]');
    const footerElement = document.querySelector('.footer');

    if (
        addToCartButton &&
        triggerElement &&
        triggerElement.offsetParent !== null &&
        addToCartButton.offsetParent !== null
    ) {
        const triggerRect = triggerElement.getBoundingClientRect();
        // Once the footer has scrolled into view there's no point keeping
        // the sticky bar pinned on top of it — hide it again there.
        const footerInView = footerElement
            ? footerElement.getBoundingClientRect().top <= window.innerHeight
            : false;

        if (triggerRect.top <= 0 && !footerInView) {
            addToCartButton.classList.add('fixed-button');
        } else {
            addToCartButton.classList.remove('fixed-button');
        }
    } else if (addToCartButton) {
        // Trigger isn't actually visible on this page (or the button is
        // hidden) — make sure it never stays stuck in the fixed state.
        addToCartButton.classList.remove('fixed-button');
    }
});

// Guard against the sticky Add to cart bar surviving a bfcache restore
// (e.g. pressing Back from a product page to a collection page), which
// was causing the fixed button to appear duplicated on the wrong page.
window.addEventListener('pageshow', function() {
    document.querySelectorAll('.fixed-button').forEach(function(el) {
        el.classList.remove('fixed-button');
    });
});

document.addEventListener('DOMContentLoaded', () => {
	const navItems = document.querySelectorAll('.hg-nav-items');
	const allImages = document.querySelectorAll('.hg-nav-item-image');

	allImages.forEach(img => img.classList.remove('is-active'));

	navItems.forEach(item => {
		item.addEventListener('mouseenter', () => {
			const target = item.getAttribute('data-nav-target');
			allImages.forEach(img => img.classList.remove('is-active'));

			if (target) {
				const targetImage = document.querySelector(`[data-nav-image="${target}"]`);
				if (targetImage) {
					targetImage.classList.add('is-active');
				}
			}
		});
	});
});
